import { getUserId } from "App/services/idpTokenService";
import { VERPersonaToken, VERUserVerificationStatus } from "Shared/models/swagger/ver";
import { APIResponse, MS_API } from "Shared/services/apiInterface";

enum UserVerificationURIs {
  BaseApi         = '/v1/users',
  BaseApiV2       = '/v2/users',
  StatusApi       = '/status',
  PersonaTokenApi = '/persona/token'
}

/**
 *
 * @returns {Promise<AxiosResponse>}
 */
const getUserVerificationStatus = (): Promise<APIResponse<VERUserVerificationStatus>> => {
  const userId = getUserId();

  return MS_API({
    method : 'GET',
    baseURL: process.env.REACT_APP_VER_BASE_URL,
    url    : `${UserVerificationURIs.BaseApiV2}/${userId}${UserVerificationURIs.StatusApi}`
  });
};

/**
 * Get Persona token (inquiry-id) for Persona verification redirect
 * @returns {Promise<AxiosResponse>}
 */
const getUserVerificationPersonaToken = (): Promise<APIResponse<VERPersonaToken>> => {
  const userId = getUserId();

  return MS_API({
    method : 'GET',
    baseURL: process.env.REACT_APP_VER_BASE_URL,
    url    : `${UserVerificationURIs.BaseApi}/${userId}${UserVerificationURIs.PersonaTokenApi}`
  });
};

export {
  getUserVerificationPersonaToken,
  getUserVerificationStatus,
  UserVerificationURIs
};